var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.workflowDefinition)?_c('div',[_c('RawJsonToggler',{attrs:{"json":_vm.workflowDefinition}}),_c('h1',[_vm._v(_vm._s(_vm.workflowDefinition.name))]),_c('Fieldset',{attrs:{"legend":"Actions"}},[(!_vm.readOnly)?_c('router-link',{attrs:{"tag":"button","to":{
        name: 'workflowDefinitionEdit',
        params: {
          workflowDefinitionName: _vm.workflowDefinitionName,
          workflowDefinitionVersion: _vm.workflowDefinitionVersion
        }
      }}},[_vm._v("\n      Edit\n    ")]):_vm._e(),(!_vm.readOnly)?_c('button',{on:{"click":function($event){return _vm.removeWorkflowDefinition([
          _vm.workflowDefinitionName,
          _vm.workflowDefinitionVersion
        ])}}},[_vm._v("\n      Remove\n    ")]):_vm._e()],1),_c('DataList',{attrs:{"data":_vm.workflowDefinition,"attributes":_vm.attributes}}),_c('DataTable',{attrs:{"caption":"Tasks","rowKeys":['name'],"rows":_vm.workflowDefinition.tasks,"actions":[],"columns":[
      { name: 'name', type: 'text' },
      { name: 'taskReferenceName', type: 'text' },
      { name: 'type', type: 'text' }
    ]}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }